/*
Pass rows of CSV and this function will actually download the CSV with the passed file name
 */
export function downloadAsCSV(csv: string[], filename: string) {
  const csv_string = csv.join('\n')
  const link = document.createElement('a')
  link.style.display = 'none'
  link.setAttribute('target', '_blank')
  link.setAttribute(
    'href',
    'data:text/csv;charset=utf-8,' + encodeURIComponent(csv_string),
  )
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
